import React from "react";
import { StyleSheet, View } from "react-native";
import { useComponent, useHideSchedule } from "../providers/ConfigProvider";
import { MediaContentCarosel } from "../components/MediaContentCarosel";
import { TextCards } from "../components/TextCards";
import { PaginatedEvents } from "../components/PaginatedEvents";
import { TemplateProps } from "../../types";
import { BackgroundGradient } from "../components/BackgroundGradient";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { BorderedContainer } from "../components/BorderedContainer";
import { Spacer } from "../components/ViewComponents";
import { TopBar } from "../components/TopBar";

const makeLayoutStyles = (theme: ThemeOptions) => {
  return StyleSheet.create({
    page: {
      flex: 1,
    },
    container: {
      flex: 1,
      flexDirection: "column",
    },
    mainContent: {
      flex: 1,
      flexDirection: "row",
      paddingHorizontal: theme.spacing.regular,
      paddingBottom: theme.spacing.medium,
    },
    cardContainer: {
      backgroundColor: theme.toRgba(theme.contrastColor, 0.15),
      borderWidth: theme.borderWidth.large,
      borderRadius: theme.borderRadius.large,
      borderColor: theme.toRgba(theme.contrastColor, 0.1),
      overflow: "hidden",
    },
    leftColumn: {
      padding: theme.scaled(2),
      flexGrow: 5,
    },
    rightColumnFooter: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "space-between",
    },
    paginationText: {
      fontSize: theme.fontSize.small,
      color: theme.backgroundText,
    },
  });
};

export const LLayout = ({ onLoopComplete }: TemplateProps) => {
  const theme = useTheme();
  const styles = makeLayoutStyles(theme);
  const schedule = useComponent("schedule", "right_schedule");
  const media = useComponent("media", "media_content");
  const cards = useComponent("cards", "bottom_content_cards");
  const hideSchedule = useHideSchedule();

  return (
    <View style={styles.container}>
      <BackgroundGradient background={theme.background} accent={theme.accent} />
      <View style={styles.container}>
        <TopBar />
        <View style={styles.mainContent}>
          <View style={styles.leftColumn}>
            <BorderedContainer variant="secondary" style={{ flexGrow: 4 }}>
              <MediaContentCarosel
                onLoopComplete={onLoopComplete}
                data={media ?? []}
              />
            </BorderedContainer>
            {cards != null && cards.cards.length > 0 && (
              <BorderedContainer
                variant="secondary"
                style={{ marginTop: theme.spacing.medium }}
              >
                <TextCards data={cards} />
              </BorderedContainer>
            )}
          </View>
          {!hideSchedule && (
            <>
              <Spacer size="small" />
              <BorderedContainer
                variant="secondary"
                style={{ flexGrow: 3, paddingTop: theme.spacing.medium }}
              >
                <PaginatedEvents
                  style={{ flexGrow: 5 }}
                  events={schedule?.events ?? []}
                  timeZone={schedule?.timeZone}
                  disableLoop={schedule?.disableLoop}
                  nextDayEvents={schedule?.nextDayEvents}
                />
              </BorderedContainer>
            </>
          )}
        </View>
      </View>
    </View>
  );
};
